import { toast } from "sonner";

export async function copyText(text, msg = "Copied — ready to paste") {
  try {
    await navigator.clipboard.writeText(text);
  } catch (e) {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    if (!ok) return toast.error("Couldn't copy automatically — select the text and press Ctrl/Cmd+C");
  }
  toast.success(msg);
}
